module.exports = __webpack_public_path__ + "static/media/Flag-Yemen.1102cbc6.svg";